import { render, staticRenderFns } from "./newsPage09.vue?vue&type=template&id=07530592&scoped=true&"
import script from "./newsPage09.vue?vue&type=script&lang=js&"
export * from "./newsPage09.vue?vue&type=script&lang=js&"
import style0 from "./newsPage09.vue?vue&type=style&index=0&id=07530592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07530592",
  null
  
)

export default component.exports